export default __webpack_public_path__ + "static/media/allgemein_59.5cc12b34.jpg";